<template>
    <section class="d-flex w-100 weather-report">
        <!-- LOADING -->
        <section class="d-flex w-100" v-if="loading">
            <!-- ! not here -->
            <div class="d-flex flex-column justify-content-between w-15 me-2">
                <div class="d-flex justify-content-between w-100">
                    <span class="shimmer-loading w-30 p-2"></span>
                    <span class="shimmer-loading w-30 p-2"></span>
                </div>
                <span class="shimmer-loading w-100 mt-1"></span>
            </div>
            <div class="d-flex flex-column justify-content-between w-5">
                <span class="shimmer-loading w-100 p-1"></span>
                <span class="shimmer-loading w-100 p-1"></span>
            </div>
        </section>
        <!-- DATA -->
        <div class="d-flex w-100 justify-content-center" v-if="currentData && forecastData && !loading">
            <i class="me-2 wi font-size-3xl" :class="getClassOfCurrentWeather"></i>
            <!-- CURRENT WEATHER -->
            <section class="d-flex flex-column justify-content-around mt-n1">
                <div class="d-flex align-items-center justify-content-center fw-bold">
                    <span> {{ locationData.city }}, {{ locationData.state }} </span>
                </div>
                <div class="d-flex align-items-center">
                    Today: <span :class="`${isCelsius ? 'celsius' : 'degree'} ps-2`">{{ temperature }}</span>
                </div>
            </section>
            <i
                class="fas fa-caret-down ms-2 font-size-xs cursor-pointer d-flex align-items-center"
                @click="toggleWeatherForecast()"
                ref="toggleIconRef"
            ></i>
            <!-- FORECAST  -->
            <div class="d-flex flex-column weather-forecast" v-if="showWeatherForecast" ref="weatherForecastRef">
                <div class="d-flex">
                    <div
                        v-for="(data, index) in forecastData"
                        :key="`temp-${index}`"
                        class="me-3 flex-column align-items-center d-flex"
                    >
                        <b class="font-size-base">
                            {{ formatingDateOrTime(data.date, durationDateFormat) }}
                        </b>
                        <i class="wi font-size-lg my-1" :class="weatherClass(data.id)"></i>
                        <span>
                            <span class="font-size-2xs degree">{{ data.hi }}</span>
                            <span class="font-size-2xs degree"> / {{ data.lo }} </span>
                        </span>
                    </div>
                </div>
                <div class="d-flex justify-content-end pe-2 py-2 white-background">
                    <button class="btn btn-sm text-end" @click="openSettings()">Edit</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./WeatherReport.ts"></script>
<style src="./WeatherReport.scss"></style>
